import { render, staticRenderFns } from "./MortalityReportDashboard.vue?vue&type=template&id=6cd452c8&scoped=true"
import script from "./MortalityReportDashboard.vue?vue&type=script&lang=js"
export * from "./MortalityReportDashboard.vue?vue&type=script&lang=js"
import style0 from "./MortalityReportDashboard.vue?vue&type=style&index=0&id=6cd452c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cd452c8",
  null
  
)

export default component.exports